import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import CLS_REGIONS from 'constants/clsRegions';

const FaqItem = ({ question, answer }) => (
  <div className="flex gap-2">
    <Icon
      className="mt-0.5 shrink-0 text-primary-300"
      name="chat"
      size="size2"
      aria-hidden
    />
    <div className="flex flex-col gap-4">
      <Text
        as="p"
        className="text-base font-bold text-neutral-low-400 dark:text-neutral-high-200"
      >
        {question}
      </Text>
      <Text
        as="p"
        className="text-base text-neutral-low-300 dark:text-neutral-high-300"
      >
        {answer}
      </Text>
    </div>
  </div>
);

FaqItem.propTypes = {
  answer: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
};

const FaqSection = ({ className, faqItems, storeName }) => {
  if (!faqItems?.length) return null;

  return (
    <section
      aria-label={`Perguntas frequentes sobre ${storeName}`}
      className={twMerge('flex flex-col gap-10', className)}
      // CLS attribution marker, read by lib/webVitals/reportCls
      data-cls-region={CLS_REGIONS.FAQ}
    >
      <Heading
        as="h2"
        className="border-b border-neutral-high-400 pb-6 text-2xl font-semibold text-neutral-low-400 dark:border-neutral-low-200 dark:text-neutral-high-200"
        size="size4"
      >
        {`Perguntas frequentes ${storeName}`}
      </Heading>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-x-11 md:gap-y-6">
        {faqItems.map(({ question, answer }) => (
          <FaqItem key={question} answer={answer} question={question} />
        ))}
      </div>
    </section>
  );
};

FaqSection.propTypes = {
  className: PropTypes.string,
  faqItems: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.string.isRequired,
    })
  ).isRequired,
  storeName: PropTypes.string.isRequired,
};

export default FaqSection;
